export const SCROLL = {
  POSITION: {
    NEAREST: "nearest",
    TOP: "start",
    CENTER: "center",
    BOTTOM: "end",
  },
  BEHAVIOR: {
    SMOOTH: "smooth",
    AUTO: "auto",
  },
};
